import { useState, useEffect } from 'react';
import {
  ConsentCategories,
  DEFAULT_CONSENT,
  getCkyConsentCategories
} from '@/util/cookie_consent_client';

export function useCookieConsent(): ConsentCategories {
  const [consent, setConsent] = useState<ConsentCategories>(DEFAULT_CONSENT);

  useEffect(() => {
    // Read whatever CookieYes already has (handles returning users)
    setConsent(getCkyConsentCategories());

    // Re-sync when CookieYes finishes loading and whenever the user updates their preferences
    const handler = () => setConsent(getCkyConsentCategories());
    document.addEventListener('cookieyes_banner_load', handler);
    document.addEventListener('cookieyes_consent_update', handler);
    return () => {
      document.removeEventListener('cookieyes_banner_load', handler);
      document.removeEventListener('cookieyes_consent_update', handler);
    };
  }, []);

  return consent;
}
